import { render } from "./recruitment.vue?vue&type=template&id=3c7a2ac7&scoped=true"
import script from "./recruitment.vue?vue&type=script&lang=js"
export * from "./recruitment.vue?vue&type=script&lang=js"

import "./recruitment.vue?vue&type=style&index=0&id=3c7a2ac7&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c7a2ac7"]])

export default __exports__